import PanelUserManagement from '../../shared/panelUsers/PanelUserManagement';

function OwnerPanelUserManagement() {
  return (
    <PanelUserManagement
      panel="owner"
      panelLabel="Owner Panel"
      subtitle="Only owners can add users here — they all share the single owner panel at /owner"
      exportSlug="owner-panel-users"
    />
  );
}

export default OwnerPanelUserManagement;
